import Http from "@/libs/axios";
import moment from "moment";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    notifications: [],
  },
  getters: {
    items: (state) => {
      return state.items;
    },
    item: (state) => {
      return state.item;
    },
    itemSelectOptions: (state) => {
      return state.itemSelectOptions;
    },
    notifications: (state) => {
      return state.notifications;
    },
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      state.items = items;
    },
    SET_USER_SELECT_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((key) => {
        return { value: key, text: items[key] };
      });

      state.itemSelectOptions = [
        { value: null, text: "Please select one" },
        ...listOfObjects,
      ];
    },
    SET_ITEM(state, item) {
      state.item = item;
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications.map((item) => {
        if (item.type == "App\\Notifications\\AddNewCouponNotification") {
        }
        return {
          icon: "BookIcon",
          type:
            item.data.result == "success" ? "light-success" : "light-danger",
          title: item.data.title,
          subtitle: item.data.subtitle,
          read: item.read_at == null ? false : true,
          link: `${item.data.link}&read=${item.id}`,
          createdAt: item.created_at,
        };
        /* if(item.type == 'App\\Notifications\\AddNewCouponCompleted'){
          return {
            icon: "BookIcon",
            type: "light-success",
            title: "Add New Parking Coupon Complete",
            subtitle: `Receiving No: ${item.data.Rec_no}`,
            read: item.read_at == null ? false : true,
            link: `/coupons?filter=${item.data.Rec_no}&searchField=Rec_no&read=${item.id}`,
            createdAt: item.created_at
          }
        }

        if(item.type == 'App\\Notifications\\AddNewCouponFailed'){
          return {
            icon: "BookIcon",
            type: "light-danger",
            title: "Add New Parking Coupon Failed",
            subtitle: item.data.error,
            read: item.read_at == null ? false : true,
            link: `/coupons?filter=${item.data.Rec_no}&searchField=Rec_no&read=${item.id}`,
            createdAt: item.created_at
          }
        } */
      });
    },
  },
  actions: {
    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("user", { params: params })
          .then((response) => {
            commit("SET_ITEM_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    getUserSelectOptions({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get("user/select-warden-options")
          .then((response) => {
            commit("SET_USER_SELECT_OPTIONS", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    show({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        Http.get(`user/${id}`)
          .then((response) => {
            // console.log(response.data);
            commit("SET_ITEM", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("user", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    update({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.put(`user/${payload.userData.id}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changePassword({}, { password, id }) {
      console.log("change");
      return new Promise((resolve, reject) => {
        Http.post(`user/change-password/${id}`, { password: password })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    destroy({}, { id }) {
      return new Promise((resolve, reject) => {
        Http.delete(`user/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getNotifications({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get("user/notifications")
          .then((res) => {
            commit("SET_NOTIFICATIONS", res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    markAllNotificationAsRead({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get(`user/mark-all-notification-as-read`)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
